import React, { Component } from 'react';
import { t } from 'i18next'
import axios from 'axios';
import { Alert } from 'react-bootstrap';
import { API_URL } from '../../constants';

class Bookappointment extends Component {


    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            name: "",
            email: "",
            phone: ""
        }
    }

    handleSubmit(e) {
        e.preventDefault();

        axios.post(`${API_URL}/advice/`, {
            name: this.state.name,
            email: this.state.email,
            phone: this.state.phone,
            radicado: ""
        }).then((respose) => {

            if (respose.status === 200) {
                document.getElementById("server_response_success").classList.add("d-block");
                this.setState({ name: "", email: "", phone: "" })
            } else {
                document.getElementById("server_response_danger").classList.add("d-block");
            }
        }).catch((error) => {
            // console.log(error)
            document.getElementById("server_response_danger").classList.add("d-block");
        })


    }



    render() {
        return (
            <section className="book-appointment parallax section-padding" id="book-appointment">
                <div className="overlay overlay-bg-black" />
                <div className="pattern" />
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="appointment-sec">
                                <div className="row no-gutters">
                                    <div className="col-lg-6 ">
                                        <div className="padding-40 full-height bg-white">
                                            <div className="align-self-center">
                                                <div className="section-heading">
                                                    <h3 className="text-custom-blue fw-600 ">{t("do you need financial advice?")}</h3>
                                                </div>
                                                <p className="text-dark">{t("do you need financial advice? calltoaction")}</p>
                                                <h6 className="fs-20 mt-4 text-dark">{t("visit us large")}</h6>
                                                <div className="LOANLY-address">
                                                    <p className="text-dark "><span className="fw-600">{t("address")}</span> : {t("address_location")}</p>
                                                    <p className="text-dark "><span className="fw-600">{t("email")}</span> : {t("email_advice")}</p>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="right-side full-height bg-border">
                                            <div className="section-heading">
                                                <h3 className="text-white fw-600">{t("schedule your advice")}</h3>
                                            </div>
                                            <form className="form-style-2 form-style-3" onSubmit={this.handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="input-group"> <span className="input-group-preappend"><i className="fas fa-user" /></span>
                                                                <input type="text" value={this.state.name} onChange={(e) => this.setState({ name: e.currentTarget.value })} className="form-control" placeholder="Full Name" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="input-group"> <span className="input-group-preappend"><i className="fas fa-envelope" /></span>
                                                                <input type="email" value={this.state.email} onChange={(e) => this.setState({ email: e.currentTarget.value })} className="form-control" placeholder="Email Address" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="input-group"> <span className="input-group-preappend"><i className="fas fa-phone-alt" /></span>
                                                                <input type="text" value={this.state.phone} onChange={(e) => this.setState({ phone: e.currentTarget.value })} className="form-control" placeholder="Phone Number" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <button type="submit" className="btn-first btn-submit full-width">{t("schedule")}</button>
                                                        <Alert variant="success" className="d-none mt-3 mb-0" id="server_response_success">
                                                            <strong>{t("success form title")}</strong> {t("success form description")}
                                                        </Alert>
                                                        <Alert variant="danger" className="d-none mt-3 mb-0" id="server_response_danger">
                                                            <strong>{t("error form title")}</strong> {t("error form description")}
                                                        </Alert>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default Bookappointment;